import React from 'react';
import { SearchIcon, StarIcon, CheckIcon, TagIcon } from 'lucide-react';
import ServiceCard from '../components/Services/ServiceCard';
// Mock service data
const services = [{
  id: 1,
  title: 'Interior Design & Decoration',
  description: 'Professional interior design services to transform your property into a stunning living space.',
  image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1400&q=80',
  rating: 4.9,
  reviewCount: 124,
  tags: ['Verified', 'Premium'],
  price: 'From ₦250,000'
}, {
  id: 2,
  title: 'Property Cleaning Services',
  description: 'Comprehensive cleaning services for new properties, including deep cleaning and sanitization.',
  image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1400&q=80',
  rating: 4.7,
  reviewCount: 98,
  tags: ['Verified'],
  price: 'From ₦75,000'
}, {
  id: 3,
  title: 'Home Renovation & Repairs',
  description: 'Quality renovation services to upgrade your property with modern fixtures and finishes.',
  image: 'https://images.unsplash.com/photo-1574359411659-15573a27d686?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1400&q=80',
  rating: 4.8,
  reviewCount: 87,
  tags: ['Verified', 'Premium'],
  price: 'From ₦500,000'
}, {
  id: 4,
  title: 'Property Management',
  description: 'Comprehensive property management services including tenant management and maintenance.',
  image: 'https://images.unsplash.com/photo-1556155092-490a1ba16284?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1400&q=80',
  rating: 4.6,
  reviewCount: 56,
  tags: ['Verified'],
  price: 'From ₦150,000/year'
}, {
  id: 5,
  title: 'Security Installation',
  description: 'Modern security systems including CCTV, alarms, and access control for your property.',
  image: 'https://images.unsplash.com/photo-1557063673-0493e05da49f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1400&q=80',
  rating: 4.9,
  reviewCount: 42,
  tags: ['Verified', 'Premium'],
  price: 'From ₦350,000'
}, {
  id: 6,
  title: 'Garden & Landscape Design',
  description: 'Transform your outdoor spaces with professional landscaping and garden design services.',
  image: 'https://images.unsplash.com/photo-1558904541-efa843a96f01?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1400&q=80',
  rating: 4.7,
  reviewCount: 38,
  tags: ['Verified'],
  price: 'From ₦200,000'
}];
const Services = () => {
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1755">
      {/* Hero Section */}
      <div className="bg-[#FF4E00] text-white" data-id="element-1756">
        <div className="container mx-auto px-4 py-12 md:py-16" data-id="element-1757">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1758">
            <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1759">
              Property Services Marketplace
            </h1>
            <p className="text-xl mb-8" data-id="element-1760">
              Book trusted services to manage, maintain, and enhance your
              property in Nigeria, all from abroad.
            </p>
            <div className="bg-white rounded-lg p-2 flex items-center" data-id="element-1761">
              <input type="text" placeholder="Search for services..." className="flex-grow px-4 py-2 focus:outline-none text-gray-800" data-id="element-1762" />
              <button className="bg-[#FF4E00] text-white px-6 py-2 rounded-lg hover:bg-[#e64600] transition flex items-center" data-id="element-1763">
                <SearchIcon size={20} className="mr-2" data-id="element-1764" />
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Service Categories */}
      <div className="container mx-auto px-4 py-12" data-id="element-1765">
        <div className="text-center mb-12" data-id="element-1766">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-1767">
            Our Service Categories
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1768">
            Browse through our range of verified services to enhance and
            maintain your property.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12" data-id="element-1769">
          {[{
          name: 'Interior Design',
          icon: '🏠'
        }, {
          name: 'Cleaning',
          icon: '🧹'
        }, {
          name: 'Renovation',
          icon: '🔨'
        }, {
          name: 'Property Management',
          icon: '📋'
        }, {
          name: 'Security',
          icon: '🔒'
        }, {
          name: 'Landscaping',
          icon: '🌳'
        }].map((category, index) => <button key={index} className="bg-white rounded-lg p-4 text-center hover:shadow-md transition" data-id="element-1770">
              <div className="text-3xl mb-2" data-id="element-1771">{category.icon}</div>
              <div className="font-medium" data-id="element-1772">{category.name}</div>
            </button>)}
        </div>
        {/* Featured Services */}
        <div className="mb-12" data-id="element-1773">
          <div className="flex justify-between items-center mb-6" data-id="element-1774">
            <h2 className="text-2xl font-bold text-gray-800" data-id="element-1775">
              Featured Services
            </h2>
            <div className="flex space-x-2" data-id="element-1776">
              <button className="px-3 py-1 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-1777">
                All
              </button>
              <button className="px-3 py-1 border border-[#FF4E00] bg-[#FFF1EC] text-[#FF4E00] rounded-lg" data-id="element-1778">
                Popular
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-1779">
                New
              </button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1780">
            {services.map(service => <ServiceCard key={service.id} service={service} data-id="element-1781" />)}
          </div>
        </div>
        {/* How It Works */}
        <div className="bg-white rounded-lg shadow-sm p-8 mb-12" data-id="element-1782">
          <div className="text-center mb-10" data-id="element-1783">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-1784">
              How It Works
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1785">
              Booking services for your property in Nigeria has never been
              easier, even from abroad.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1786">
            {[{
            title: 'Browse & Select',
            description: 'Browse through our marketplace of verified service providers and select the service you need.',
            icon: '🔍'
          }, {
            title: 'Book & Pay Securely',
            description: 'Book your service and make secure payments through our escrow system.',
            icon: '💳'
          }, {
            title: 'Track & Approve',
            description: 'Track the service progress and approve completion to release payment.',
            icon: '✅'
          }].map((step, index) => <div key={index} className="text-center" data-id="element-1787">
                <div className="text-4xl mb-4" data-id="element-1788">{step.icon}</div>
                <h3 className="text-xl font-bold mb-2" data-id="element-1789">{step.title}</h3>
                <p className="text-gray-600" data-id="element-1790">{step.description}</p>
              </div>)}
          </div>
        </div>
        {/* Testimonials */}
        <div className="mb-12" data-id="element-1791">
          <div className="text-center mb-10" data-id="element-1792">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-1793">
              What Our Customers Say
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1794">
              Hear from property owners who have used our services from abroad.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1795">
            {[{
            quote: 'I was able to completely renovate my Lagos apartment while working in London. The service providers were professional and kept me updated with photos throughout the process.',
            name: 'Oluwaseun A.',
            location: 'London, UK',
            image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80'
          }, {
            quote: 'The interior design service transformed my empty property into a beautiful home. I was involved in every decision despite being thousands of miles away in Canada.',
            name: 'Chioma O.',
            location: 'Toronto, Canada',
            image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80'
          }, {
            quote: "The property management service has been invaluable. They handle everything from tenant issues to maintenance, giving me peace of mind while I'm in the US.",
            name: 'Emeka N.',
            location: 'Houston, USA',
            image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80'
          }].map((testimonial, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-6" data-id="element-1796">
                <div className="flex items-center mb-4" data-id="element-1797">
                  {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} size={18} className="text-yellow-400 fill-yellow-400" data-id="element-1798" />)}
                </div>
                <p className="text-gray-700 mb-6 italic" data-id="element-1799">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center" data-id="element-1800">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-1801" />
                  <div data-id="element-1802">
                    <h4 className="font-bold text-gray-800" data-id="element-1803">
                      {testimonial.name}
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-1804">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* CTA */}
        <div className="bg-[#FF4E00] text-white rounded-lg p-8 text-center" data-id="element-1805">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1806">
            Ready to Transform Your Property?
          </h2>
          <p className="text-xl mb-6 max-w-2xl mx-auto" data-id="element-1807">
            Browse our marketplace of verified service providers and book
            services for your property in Nigeria today.
          </p>
          <button className="px-8 py-3 bg-white text-[#FF4E00] font-bold rounded-lg hover:bg-gray-100 transition" data-id="element-1808">
            Explore Services
          </button>
        </div>
      </div>
    </div>;
};
export default Services;